"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _includes = _interopRequireDefault(require("lodash/includes"));

var _times = _interopRequireDefault(require("lodash/times"));

var _uniq = _interopRequireDefault(require("lodash/uniq"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactLazyLoad = _interopRequireDefault(require("react-lazy-load"));

var _reactSwipeable = require("react-swipeable");

var _chevronLeft = _interopRequireDefault(require("@spothero/icons/chevron-left"));

var _chevronRight = _interopRequireDefault(require("@spothero/icons/chevron-right"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _CarouselSlideDot = _interopRequireDefault(require("./CarouselSlideDot"));

var CarouselSlides =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(CarouselSlides, _PureComponent);

  function CarouselSlides(props) {
    var _this;

    (0, _classCallCheck2.default)(this, CarouselSlides);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CarouselSlides).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_getAlignmentClassName", function (index) {
      var _this$props = _this.props,
          currentIndex = _this$props.currentIndex,
          lazyLoad = _this$props.lazyLoad;
      var alignment;

      if (index === currentIndex - 1) {
        alignment = 'left';
      } else if (index < currentIndex - 1) {
        alignment = 'left-inactive';
      } else if (index === currentIndex) {
        alignment = 'center';

        if (lazyLoad && !_this._hasSlideLazyLoaded) {
          // the index hasn't been loaded yet and we need to check if its greater than
          // or less than the next item so that we can animate properly when using pagination
          if (index > _this._previousIndex + 1) {
            alignment = 'from-right';
          } else if (index < _this._previousIndex - 1) {
            alignment = 'from-left';
          }
        }
      } else if (index === currentIndex + 1) {
        alignment = 'right';
      } else if (index > currentIndex + 1) {
        alignment = 'right-inactive';
      }

      if (_this._totalSlides >= 3) {
        if (index === 0 && currentIndex === _this._totalSlides - 1) {
          // set first slide as right slide if were sliding right from last slide
          alignment = 'right';
        } else if (index === _this._totalSlides - 1 && currentIndex === 0) {
          // set last slide as left slide if were sliding left from first slide
          alignment = 'left';
        }
      }

      if (index === currentIndex || index === _this._previousIndex) {
        alignment = "".concat(alignment, " CarouselSlide-animating");
      }

      return "CarouselSlide-".concat(alignment);
    });
    _this._totalSlides = _react.Children.count(props.children);
    _this.state = {
      lazyLoadedSlides: []
    };
    return _this;
  }

  (0, _createClass2.default)(CarouselSlides, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._lazyLoadSlide(this.props.currentIndex);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      this._previousIndex = prevProps.currentIndex;

      this._lazyLoadSlide(this.props.currentIndex);
    }
  }, {
    key: "_lazyLoadSlide",
    value: function _lazyLoadSlide(index) {
      var _this$props2 = this.props,
          lazyLoad = _this$props2.lazyLoad,
          preload = _this$props2.preload;
      var lazyLoadedSlides = this.state.lazyLoadedSlides;

      if (!lazyLoad) {
        return;
      }

      this._hasSlideLazyLoaded = (0, _includes.default)(lazyLoadedSlides, index);

      if (this._hasSlideLazyLoaded) {
        return;
      }

      var nextIndex = index + 1 === this._totalSlides - 1 ? 0 : index + 1;
      var previousIndex = index - 1 <= 0 ? this._totalSlides - 1 : index - 1;
      var loadedSlides = preload ? (0, _concat.default)(lazyLoadedSlides).call(lazyLoadedSlides, [index, nextIndex, previousIndex]) : (0, _concat.default)(lazyLoadedSlides).call(lazyLoadedSlides, [index]);
      this.setState({
        lazyLoadedSlides: (0, _uniq.default)(loadedSlides)
      });
    }
  }, {
    key: "_renderArrows",
    value: function _renderArrows() {
      var _this$props3 = this.props,
          onPreviousClick = _this$props3.onPreviousClick,
          onNextClick = _this$props3.onNextClick;
      return _react.default.createElement("div", {
        className: "Carousel-arrows"
      }, _react.default.createElement(_Button.default, {
        className: "Carousel-previous",
        onClick: onPreviousClick
      }, _react.default.createElement(_chevronLeft.default, null)), _react.default.createElement(_Button.default, {
        className: "Carousel-next",
        onClick: onNextClick
      }, _react.default.createElement(_chevronRight.default, null)));
    }
  }, {
    key: "_renderDots",
    value: function _renderDots() {
      var _this$props4 = this.props,
          currentIndex = _this$props4.currentIndex,
          onDotClick = _this$props4.onDotClick;
      return _react.default.createElement("div", {
        className: "CarouselDots"
      }, (0, _times.default)(this._totalSlides, function (i) {
        return _react.default.createElement(_CarouselSlideDot.default, {
          key: i,
          dotIndex: i,
          isDotSelected: currentIndex === i,
          onDotClick: onDotClick
        });
      }));
    }
  }, {
    key: "_renderSlides",
    value: function _renderSlides() {
      var _this2 = this;

      var _this$props5 = this.props,
          lazyLoad = _this$props5.lazyLoad,
          children = _this$props5.children;
      return _react.default.createElement("div", {
        className: "CarouselSlides-container"
      }, (0, _map.default)(_react.Children).call(_react.Children, children, function (slide, i) {
        var slideClasses = (0, _classnames.default)(slide.props.className, _this2._getAlignmentClassName(i));
        var clonedSlide = (0, _react.cloneElement)(slide, {
          className: slideClasses
        });

        if (lazyLoad) {
          if ((0, _includes.default)(_this2.state.lazyLoadedSlides, i)) {
            return clonedSlide;
          } else {
            return null;
          }
        } else {
          return clonedSlide;
        }
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          className = _this$props6.className,
          showArrows = _this$props6.showArrows,
          showDots = _this$props6.showDots,
          lazyLoad = _this$props6.lazyLoad,
          onPreviousClick = _this$props6.onPreviousClick,
          onNextClick = _this$props6.onNextClick;
      var classes = (0, _classnames.default)('CarouselSlides', className);
      return _react.default.createElement("div", {
        className: classes
      }, _react.default.createElement(_reactSwipeable.Swipeable, {
        onSwipedLeft: onNextClick,
        onSwipedRight: onPreviousClick
      }, lazyLoad ? _react.default.createElement(_reactLazyLoad.default, {
        offsetVertical: 100
      }, this._renderSlides()) : this._renderSlides()), showArrows && this._renderArrows(), showDots && this._totalSlides > 1 && this._renderDots());
    }
  }]);
  return CarouselSlides;
}(_react.PureComponent);

exports.default = CarouselSlides;
(0, _defineProperty2.default)(CarouselSlides, "defaultProps", {
  currentIndex: 0,
  showArrows: true,
  lazyLoad: true,
  preload: true
});